export default __webpack_public_path__ + "static/media/userManagement.6b97ff73.svg";